import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteUser, getUsers } from "../../redux/actions/userAction";
import { confirmPopup } from "primereact/confirmpopup";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUsers(setLoading));
    }, [dispatch]);

    let { allUsers } = useSelector((state) => state.user);

    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter(
                (item) =>
                    item?.fullName?.includes(search) ||
                    item?.mobile?.includes(search) ||
                    item?.email?.includes(search)
            );
        }
        return data;
    };

    allUsers = getFilteredData(allUsers, search);
    allUsers = allUsers.map((item) => ({
        ...item,
        time: new Date(item.time),
    }));
    let inActiveUsers = allUsers.filter((item) => item.isDeleted);
    inActiveUsers = getFilteredData(inActiveUsers, search);

    const onDelete = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to delete this user? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteUser(id)),
            reject: () => { },
        });
    };

    const headerContent = () => {
        return (
            <>
            </>
        );
    };

    return {
        allUsers,
        inActiveUsers,
        loading,
        history,
        search,
        setSearch,
        onDelete,
        headerContent,
    };
}
